import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { withTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import './index.less';

import { withRouter } from '../../hooks/withRouter';
import BalanceGroupsTable from '../../components/BalanceGroupsTable';
import BalanceGroupView from '../../components/BalanceGroupView';
import PageHeaderBar from '../../components/PageHeaderBar';
import BalanceGroupMemberView from '../../components/BalanceGroupMemberView';


const BalanceGroups = ({ t }) => (
  <>
    <PageHeaderBar
      title={t('balanceContainer.title.balanceGroups')}
      data-testid="page__header-bar"
    />
    <Layout.Content className="layout__container__page__content balancegroups-table__placeholder">
      <BalanceGroupsTable />
    </Layout.Content>
    <Routes>
      <Route
        path="membership/:id"
        Component={BalanceGroupMemberView}
      />
      <Route
        path=":id"
        Component={BalanceGroupView}
      />
    </Routes>
  </>
);

BalanceGroups.displayName = 'BalanceGroups';
BalanceGroups.propTypes = {
  t: PropTypes.func.isRequired,
};

const BalanceGroupsTranslated = withTranslation()(BalanceGroups);

export default withRouter(BalanceGroupsTranslated);
export {
  BalanceGroups as PureComponent,
};
